import FuckAdBlock from 'fuckadblock';
import log from "./log";

class adblockDetect{
	constructor(){
		
		this.adBlockNotDetected = this.adBlockNotDetected.bind(this);
		this.adBlockDetected = this.adBlockDetected.bind(this);
		
		// Recommended audit because AdBlock lock the file 'fuckadblock.js'  
		// If the file is not called, the variable does not exist 'fuckAdBlock' 
		// This means that AdBlock is present 
		if(typeof fuckAdBlock === 'undefined') {
		    this.adBlockDetected();
		} else {
		    fuckAdBlock.on(true, this.adBlockDetected).onNotDetected(this.adBlockNotDetected);
		}
		 
		fuckAdBlock.setOption({
		    debug: false,
		    checkOnLoad: true,
		    resetOnEnd: false
		});



	}
	adBlockNotDetected() {
	    window.abd = false;
	    $("body").trigger("abd-event")
	}
		// Function called if AdBlock is detected 
	adBlockDetected() {
	    window.abd = true;
	    $("body").trigger("abd-event")
	}
		 
}

export default adblockDetect;